import { Drawer, Form, Row, Col, Input, Select, Button } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Close from "../../../../assets/images/close-x.svg";

const { Option } = Select;

const SMReturnReasonDrawer = ({
  reasonPopup,
  setReasonPopup,
  setIsInputFocused,
  reasonForm,
  onFinish,
  posConfig,
  returnReasons,
}) => {
  return (
    <Drawer
      placement="bottom"
      height="53vh"
      maskClosable={false}
      title={
        <div style={{ display: "flex", alignItems: "center", height: "2vh" }}>
          <p
            style={{
              fontSize: "2vw",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            Reason for Return
          </p>
          <img
            src={Close}
            onClick={() => {
              setReasonPopup(false);
              setIsInputFocused(false);
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              cursor: "pointer",
            }}
          />
        </div>
      }
      closeIcon={null}
      className="filter"
      styles={{ body: { paddingTop: 0 } }}
      open={reasonPopup}
      onClose={() => {
        setReasonPopup(false);
        setIsInputFocused(false);
      }}
      footer={null}
    >
      <Form layout="vertical" form={reasonForm} onFinish={onFinish}>
        <Row gutter={16}>
          {posConfig?.showReferenceNo === "Y" ? (
            <Col span={8} offset={4}>
              <Form.Item label="Reference No" name="referenceNo">
                <Input />
              </Form.Item>
            </Col>
          ) : null}
          {posConfig?.showReason === "Y" ? (
            <Col span={8}>
              <Form.Item label="Reason" name="reason">
                <Select>
                  {returnReasons?.map((res) => (
                    <Option key={res.returnReasonId} value={res.returnReasonId}>
                      {res.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          {posConfig?.showRemarks === "Y" ? (
            <Col span={8} offset={4}>
              <Form.Item label="Remarks" name="remarks">
                <TextArea />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Row>
          <Col span={24} style={{ display: "flex", float: "left", height: "100%" }}>
            <div style={{ flex: 1 }}></div>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  background: "#0F0718",
                  color: "#fff",
                  marginTop: "auto",
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default SMReturnReasonDrawer;
